import { render, staticRenderFns } from "./ChartLoader.vue?vue&type=template&id=631bb94c"
import script from "./ChartLoader.vue?vue&type=script&lang=js"
export * from "./ChartLoader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports